import { apiRequest } from "./apiHelper";

export const notificationsAPI = {
  // GET /api/notifications/get
  getNotifications: async (params = {}) => {
    // Ensure notification listing is always fetched fresh (avoid cached 304 responses)
    const resp = await apiRequest("get", "/notifications/get", {}, { params, headers: { "Cache-Control": "no-cache" } });
    // apiRequest returns an object with `data` field (per backend sendSuccess)
    // Normalize to { items, total }
    const items = resp?.data?.items || [];
    const total = resp?.data?.total || 0;
    return { items, total };
  },

  // GET /api/notifications/unread-count
  getUnreadCount: async () => {
    const resp = await apiRequest("get", "/notifications/unread-count");
    // Backend returns { data: { count } }
    const count = resp?.data?.count ?? resp?.count ?? 0;
    return count;
  },

  // POST /api/notifications/mark-read/:id
  markRead: async (id) => {
    const resp = await apiRequest("post", `/notifications/mark-read/${id}`);
    return resp;
  },

  // POST /api/notifications/mark-all-read
  markAllRead: async (type) => {
    const data = type ? { type } : {};
    const resp = await apiRequest("post", `/notifications/mark-all-read`, data);
    return resp;
  },
};

// no default export
